"use client";

import AgesFilter from "@/app/[locale]/components/course/AgesFilter";
import CourseCard from "@/app/[locale]/components/course/CourseCard";
import { CousrsListItemType } from "@/app/types";

import { Link } from "@/app/config/navigation";
import React, { useState } from "react";
import CourseCardSkeleton from "./CourseCardSkeleton";
import AgesFiltersSkeleton from "./AgesFilterSkeleton";
import SearchInput from "../inputs/SearchInput";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import Highlighter from "../typography/Highlighter";
import { colors } from "@/app/config/styles";
import { sortArrayBySequence } from "@/app/utils/sorting";

function OurCourses({
  courses,
  countToShow = 6,
  search = false,
}: {
  courses: CousrsListItemType[];
  countToShow?: number;
  search?: boolean;
}) {
  const [filters, setFilters] = useState({
    minAge: 0,
    maxAge: 100,
  });
  const router = useRouter();

  const filteredCourses = courses?.filter(
    (course) =>
      parseInt(course?.age) >= filters.minAge &&
      parseInt(course?.age) <= filters.maxAge &&
      course.isActive
  );
  const t = useTranslations("courses");
  const sortedCourses = sortArrayBySequence(filteredCourses);
  return (
    <div className="py-14 " id="agesFilter">
      <div className="lg:container text-primary">
        <div className="max-md:container">
          <h2 className="text-[22px]  font-bold m-auto w-fit lg:text-[3.75rem]">
            {t("our_courses")}
          </h2>
          <p className="text-[16px] lg:text-[1.875rem] font-light max-w-[36.5rem] mx-auto leading-[20px] lg:leading-[40px]  text-center">
            <Highlighter iKey="courses.description" color={colors.yellow} />
          </p>

          {search && (
            <div className="max-w-[36.5rem] m-auto lg:mt-[3.75rem] mt-[20px]">
              {" "}
              <SearchInput
                onChange={(e) => {
                  router.replace(`/courses?search=${e.target.value}`);
                }}
              />
            </div>
          )}

          {courses ? (
            <AgesFilter
              onChange={(value) => {
                setFilters({
                  minAge: value[0],
                  maxAge: value[value.length - 1],
                });
              }}
            />
          ) : (
            <AgesFiltersSkeleton />
          )}
        </div>

        <div
          className={`  max-lg:px-[29px]  px-[5px] py-[10px] lg:p-0   lg:grid grid-cols-1 lg:grid-cols-3  gap-10 ${
            countToShow <= 6 ? "scroll flex max-lg:overflow-x-auto " : " grid"
          }`}
        >
          {courses
            ? sortedCourses
                ?.slice(0, countToShow)
                ?.map((course, index) => (
                  <CourseCard key={course.id} course={course} index={index} />
                ))
            : [1, 2, 3, 4, 5, 6]?.map((item, index) => (
                <CourseCardSkeleton key={item} />
              ))}
        </div>
        {countToShow <= 6 && (
          <Link
            href="/courses"
            className="flex justify-center items-center mt-16  transition-all  ease-in-out  duration-300  hover:font-bold text-[1.87rem] gap-3 group "
          >
            {t("see_all")}
            <div className="rounded-full  group-hover:bg-primary rtl:group-hover:-translate-x-3 group-hover:translate-x-3 bg-inherit   transition-all  ease-in-out  duration-300  w-[1.85rem] h-[1.85rem] flex items-center justify-center">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.109"
                height="8.377"
                viewBox="0 0 15.109 8.377"
                className={` rotate-90 rtl:rotate-[-90deg] lg:w-[16px] lg:h-[16px] text-primary `}
              >
                <path
                  id="Path_49625"
                  data-name="Path 49625"
                  d="M-14235-22930l5.834,5.359,5.742-5.359"
                  className="stroke-primary group-hover:stroke-white transition-all  duration-300"
                  transform="translate(-14221.657 -22923.391) rotate(180)"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.5"
                />
              </svg>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}

export default OurCourses;
